import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, useLocation } from 'react-router';

import ContentPageContainer from 'containers/ContentPageContainer';
import LoadingPage from 'pages/LoadingPage';
import NotFoundPage from 'pages/NotFoundPage';
import { State } from 'store/main';
import { fetchPage } from 'store/main/ducks/contents';
import { hasParam } from 'utils/url';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const ContentPageContainerContainer = ({
  slug,
  amp,
}: {
  slug: string;
  amp: string;
}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { contents, mainSearch } = useSelector((state: State) => ({
    contents: state.contents,
    mainSearch: state.mainSearch,
  }));
  const { isLandingPage } = mainSearch || false;
  const contentObj = contents.byUrl[slug] || {};
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line prefer-destructuring
  const content = contentObj.content;
  const pageState = contentObj.state || 'UNFETCHED';
  const subsite =
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'subsite' does not exist on type 'unknown... Remove this comment to see the full error message
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line no-nested-ternary
    location.state && location.state.subsite // @ts-expect-error ts-migrate(2339) FIXME: Property 'subsite' does not exist on type 'unknown... Remove this comment to see the full error message
      ? location.state.subsite
      : content
      ? content.subsite
      : null;
  const hasHomePage = content && content.subsite && !!content.subsite.homePage;
  const heroSearch = content && content.heroSearch;
  const defaultSearchType =
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line no-nested-ternary
    heroSearch && heroSearch.defaultSearchFilters
      ? heroSearch.defaultSearchFilters.type
      : subsite
      ? subsite.defaultSearchType
      : 'JOB';
  const onlySearchResults = heroSearch && heroSearch.onlyResults;
  const onlyArticleResults =
    content && content.onlySearchResults && hasHomePage;
  useEffect(() => {
    if (!amp) {
      dispatch(fetchPage(slug));
    }
  }, [slug, amp, dispatch]);

  if (hasParam(location.search, 'saved')) {
    return (
      <Redirect
        to={`${location.pathname}${
          location.search ? `${location.search}&` : '?'
        }`}
      />
    );
  }

  if (
    onlySearchResults ||
    isLandingPage ||
    (onlyArticleResults && hasHomePage)
  ) {
    return <Redirect to={`${location.pathname}?q=`} />;
  }

  if (['FETCHING', 'UNFETCHED'].includes(pageState)) {
    if (amp) {
      // It's an AMP URL, but content is not already available.
      // Meaning it's disabled for that page.
      return <NotFoundPage />;
    }

    return <LoadingPage />;
  }

  if (content) {
    if (contentObj.type === 'CMS_PAGE') {
      return (
        <ContentPageContainer
          content={content}
          defaultSearchType={defaultSearchType}
        />
      );
    }
  }

  return <NotFoundPage />;
};

// eslint-disable-next-line import/no-default-export
export default ContentPageContainerContainer;
